import categoriesService from './categoriesService'

export default categoriesService



// WEBPACK FOOTER //
// ../src/services/categoriesService/index.js